"use client";

import { useEffect, useState } from "react";
import { LeaderboardRow } from "types/api";
import { getLeaderbord } from "util/api-requests";

export const useLeaderboardList = (contestId: number) => {
  const [list, setList] = useState<LeaderboardRow[]>();

  useEffect(() => {
    (async () => {
      setList(await getLeaderbord(contestId));
    })();
  }, [contestId]);

  return list;
};
